var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',[_c('b-card',[_c('ERegistrationCPSRegisterForm',{attrs:{"invitation-key":_vm.invitationKey}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }